import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import { RxDashboard } from "react-icons/rx";
import { FaAngleRight, FaAngleDown } from "react-icons/fa";
import { IoCreateOutline } from "react-icons/io5";
import { CiCircleAlert, CiBank, CiSettings } from "react-icons/ci";
import { LuWarehouse } from "react-icons/lu";
import { MdLocalOffer } from "react-icons/md";
import { TbReport } from "react-icons/tb";
import { GoMilestone } from "react-icons/go";
import { MdSupportAgent } from "react-icons/md";
import { RiGroupLine } from "react-icons/ri";
import { CgProfile } from "react-icons/cg";
import { useMyContext } from "../../../context/MyContext";
import '../../css/custom-scrollbar.css';
import { IoDocumentsOutline } from "react-icons/io5";
// import { Toaster,toast } from "react-hot-toast";
// import { useAuth } from "../../routes/Auth";
import { useAuth } from '../../../routes/Auth'
import { LogOut } from 'lucide-react';
import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import { FaShopify } from 'react-icons/fa';
// import { LuUnplug } from "react-icons/lu";
// import { FaHeadSideVirus } from "react-icons/fa";
import { GiBrain } from "react-icons/gi";
import { MdIntegrationInstructions } from "react-icons/md";
import  {Briefcase} from 'lucide-react'

const Sidebar = () => {
  const { profile_flag } = useMyContext();
  const [activeTab, setActiveTab] = useState(-1);
  const [pageTab, setPageTab] = useState(-1);
  const [activeSubTab, setActiveSubTab] = useState(-1);
  const { isToggleSidebar, setIsToggleSidebar, isDarkMode } = useMyContext();
  const navigate = useNavigate();
  const { logout } = useAuth()
  const sidebarRef = useRef(null)
  const userRole = localStorage.getItem("role");
   
  const toggleSubmenu = useCallback(
    (index, href) => {
      if (profile_flag === "0" && userRole !== "admin") {
        toast.error("Please Contact to the Support Team, Your KYC is Pending");
        return;
      }
      if (href) {
        navigate(href);
        // setIsToggleSidebar(false);
      } else {
        setActiveTab((prevActiveTab) => (prevActiveTab === index ? null : index));
      }
    },
    [profile_flag, userRole, navigate, setActiveTab]
  );

  let menuItems = [
    {
      title: "Dashboard",
      icon: <RxDashboard />,
      href: "/dashboard",
      submenu: [],
    },
    //   {
    //   title: "HRMS(ERP)",
    //   icon: <Briefcase/>,
    //   href: "/hrms",
    //   submenu: [],
    // },
    {
      title: "Shipments",
      icon: <IoCreateOutline />,
      submenu: [
        { title: "Forward Shipment", href: "/shipments/forward" },
        // { title: "Reverse Shipment", href: "/shipments/reverse" },
        // { title: "Bulk Upload List", href: "/shipments/bulkUpload" },
        { title: "Track Shipments", href: "/shipments/tracking" },
        // { title: "Pickup Request", href: "/shipments/pickuprequest" },
        { title: "View Shipments", href: "/shipments/all" },
        ,

      ],
    },
    {
      title: "Warehouse",
      icon: <LuWarehouse />,
      submenu: [
        { title: "Add Warehouse", href: "/warehouse/add" },
        { title: "All Warehouses", href: "/warehouse/all" },
      ],
    },
    // {
    //   title: "Intregation",
    //   icon: <CiCircleAlert />,
    //   submenu: [
    //     { title: "Sopify", href: "/intregration/sopify" },
    //     { title: "Whatsapp", href: "/intregration/whatsapp" },
    //   ],
    // },
      {
      title: "Integration",
      icon: <MdIntegrationInstructions/>,
      href: "/intregration",
      submenu: [],
     },
    {
      title: "Disputes",
      icon: <CiCircleAlert />,
      submenu: [
        { title: "NDR", href: "/disputes/NDR" },
        // { href: "/disputes/RTO" },
        { title: "Weight Disputes", href: "/disputes/weight" },
        { title: "Weight Upload", href: "/disputes/wightUpload" },
        { title: "All Weight Disputes", href: "/disputes/allWeightDisputes" },
      ],
    },
    { 
      title: "Payments",
      icon: <CiBank />,
      submenu: [
        { title: "Remmitance", href: "/payments/remmitance" },
        { title: "RemmitanceList", href: "/payments/remmitanceList" },
        { title: "Wallet Balance", href: "/payments/walletbalance" },
      ],
    },
      {
      title: "Label",
      icon: <IoDocumentsOutline />,
      href: "/labelCustomized",
      submenu: [],
    },
    // {
    //   title: "Risk",
    //   icon: <PiAsteriskSimpleThin />,
    //   submenu: [
    //     { title: "Claims", href: "/risk/claims/lost&damages" },
    //   ],
    // },
    {
      title: "Services",
      icon: <GoMilestone />,
      href: "/services",
      submenu: [],
    },

    {
      title: "Offers",
      icon: <MdLocalOffer />,
      submenu: [
        { title: "Set Offer", href: "/offer/setoffer" },
        { title: "All offers ", href: "/offer/viewAllOffers" },
      ],
    },

    {
      title: "Customers",
      icon: <RiGroupLine />,
      submenu: [
        { title: "ViewAllCustomer", href: "/customers/viewCustomer" },
        // { title: "Add customer", href: "/customers/addCustomer" },
        { title: "KYC Pending", href: "/customers/kycPending" },
      ],
    },
    {
      title: "Preship",
      icon: <GiBrain />,
      submenu: [
        { title: "Rate Calculator", href: "/settings/rateCalculator" },
        { title: "Servicable Pincodes", href: "/settings/pincode" },
        { title: "Rate Card", href: "/settings/rateCard" },
        // { title: "Zone", href: "/settings/account" },
        { title: "Add Pincodes", href: "/settings/addPincode" },
        { title: "Set Rate", href: "/settings/setRate" },
      ],
    },
    {
      title: "Reports",
      href: "/reports",
      icon: <TbReport />,
      submenu: [],
    },
    {
      title: "Help",
      href: "/help",
      icon: <MdSupportAgent />,
      submenu: [],
    },
    {
      title: "Setting",
      icon: <CiSettings />,
      submenu: [
        // { title: "Add Role", href: "/admin/addRole" },
        { title: "Add Employee", href: "/addEmployee" },
        { title: "All Employee", href: "/allEmployee" },
      ],
    },
    {
      title: "Profile",
      icon: <CgProfile />,
      href: "/profile",
      submenu: [],
    },

  ];

  if (userRole !== "admin") {
    menuItems.forEach(item => {
      if (item.submenu && item.title === "Disputes") {
        item.submenu = item.submenu.filter(subItem => subItem.title !== "Weight Upload");
      }
      if (item.submenu && item.title === "Disputes") {
        item.submenu = item.submenu.filter(subItem => subItem.title !== "All Weight Disputes");
      }
    });
    menuItems = menuItems.filter(item => item.title !== "Customers");
    menuItems = menuItems.filter(item => item.title !== "Offers")
    menuItems.forEach(item => {
      if (item.submenu && item.title === "Preship") {
        item.submenu = item.submenu.filter(subItem => subItem.title !== "Set Rate");
      }
    }); 
     menuItems.forEach(item => {
      if (item.submenu && item.title === "Preship") {
        item.submenu = item.submenu.filter(subItem => subItem.title !== "Add Pincodes");
      }
    }); 
    menuItems.forEach(item => {
      if (item.submenu && item.title === "Payments") {
        item.submenu = item.submenu.filter(subItem => subItem.title !== "RemmitanceList");
      }
    });
    menuItems = menuItems.filter(item => item.title !== "Setting");
    menuItems.forEach(item => {
      if (item.submenu && item.title === "Add Role") {
        item.submenu = item.submenu.filter(subItem => subItem.title !== "Add Role");
      }
    });
  } else {
    menuItems.forEach(item => {
      if (item.submenu && item.title === "Preship") {
        item.submenu = item.submenu.filter(subItem => subItem.title !== "Rate Card");
      }
      if (item.submenu && item.title === "Disputes") {
        item.submenu = item.submenu.filter(subItem => subItem.title !== "Weight Disputes");
      }
      if (item.submenu && item.title === "Payments") {
        item.submenu = item.submenu.filter(subItem => subItem.title !== "Remmitance");
      }
      menuItems = menuItems.filter(item => item.title !== "Label")
    });
  }

  useMemo(() => {
    let currRoute = window.location.pathname
    menuItems.map((item, index) => {
      if (item.href && currRoute == item.href) {
        setActiveTab(index);
        setPageTab(index);
      }
      if (item.submenu) {
        item.submenu.map((subItem, subIndex) => {
          if (subItem.href && currRoute == subItem.href) {
            setActiveTab(index);
            setActiveSubTab(subIndex);
            setPageTab(index);
          }
        });
      }
    });
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        window.innerWidth <= 768
      ) {
        setIsToggleSidebar(false);
      }
    };
    if (isToggleSidebar) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };

  }, [isToggleSidebar, setIsToggleSidebar]);

  const handleLogout = () => {
    localStorage.removeItem("user");
    navigate('/login')
    logout()
    localStorage.removeItem('cus_id')
    localStorage.removeItem('token')
    localStorage.removeItem("wallet_status");
    localStorage.removeItem("profile_flag");
    localStorage.removeItem("role");
    localStorage.removeItem("isB2BMode");
    toast.success("LogOut Sucessfully !")
  }     
  return (
    <>
      {isToggleSidebar && (
        <div ref={sidebarRef} className="w-64 h-full flex flex-col  transform transition-transform duration-300 pl-2 custom-scrollbar ">
          <ul className="flex-1">
            {menuItems.map((item, index) => (
              <li key={index}>
                <Button
                  sx={{
                    fontFamily: 'var(--font-custom-open-sans)',
                    textTransform: 'none',
                    color: isDarkMode ? 'white' : 'rgba(6, 6, 6, 0.616)',
                    width: '100%',
                    textAlign: 'left',
                    fontWeight: 'bold',
                    display: 'flex',
                    // paddingLeft:'1.5rem',
                    alignItems: 'center',
                    padding: '0.75rem 1rem',
                    transition: 'all 0.3s ease-in-out',
                    '&:hover': {
                      backgroundColor: 'rgba(128,128,128, 0.3)',
                      color: isDarkMode ? 'white' : 'rgba(6, 6, 6, 0.616)',
                      boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.2)',
                      transform: 'scale(1.05)', 
                    },
                  }}
                  onClick={() => toggleSubmenu(index, item.href)}
                >
                  <span className={activeTab == index ? "icon mr-2 text-xl text-emerald-600 " : "icon mr-2 text-xl text-emerald-400 "}>
                    {item.icon}
                  </span>
                  <span className="pl-3x">
                    {item.title}
                  </span>
                  <span
                    className="arrow ml-auto"
                  >
                    {item.submenu.length ? (activeTab === index ? <FaAngleDown /> : <FaAngleRight />) : ""}
                  </span>
                </Button>
                {item.submenu.length > 0 && activeTab === index && (
                  <div className="submenuWrapper pl-6">
                    <ul className="submenu text-custom-gray border-l pl-4 border-gray-600">
                      {item.submenu.map((subItem, subIndex) => (
                        <li
                          key={subIndex}
                          className={`py-1 px-1 dark:text-white ${activeTab === index && activeSubTab === subIndex
                            ? "text-customPurple font-bold dark:text-gray-700"
                            : "text-gray-700 font-bold dark:text-customPurple"
                            }`}
                        >
                          <Link
                            to={subItem.href}
                            className="text-sm font-semibold hover:opacity-70 hover:text-customPurple transition-opacity duration-300"
                            aria-label={subItem.title}
                            style={{
                              fontFamily: 'var(--font-custom-open-sans)',
                              color: isDarkMode ? (pageTab === index && activeSubTab === subIndex ? '#A76EDB' : 'white') : (activeTab === index && activeSubTab === subIndex ? '#A76EDB' : 'rgba(6, 6, 6, 0.616)'),
                            }}
                          >
                            {subItem.title}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </li>
            ))}
          </ul>
          {/* <span className="mt-12 mb-12 ml-10 w-32 font-sans">
          <Button onClick={handleLogout}  sx={{ textTransform: 'capitalize', 
            color : isDarkMode ? 'white' : 'white',
            backgroundColor:"#3B82F6",
            marginLeft:"42px",
            }} 
            className=' text-white bg-blue-500 hover:text-white hover:bg-blue-600 w-32 font-sans h-8 '>
          LogOut
        </Button>
        </span> */} 
          <div className="bg-blue-200 p-6 rounded-lg shadow-md  md:mt-8 md:mb-10 mt-8 mb-10 relative">
            {/* <div className="absolute top-6 left-7 w-8 h-8  bg-blue-300 rounded-full -translate-x-1/2 -translate-y-1/2"></div>
                <div className="absolute  right-4 bottom-16 w-12 h-12   bg-blue-200 rounded-full translate-x-1/3 translate-y-1/3"></div> */}
            <button
              onClick={handleLogout}
              className="flex items-center justify-center bg-blue-500 hover:bg-blue-600 text-white font-sans font-medium py-2 px-4 ml-7 rounded-md transition duration-300 ease-in-out w-28"
            >
              <LogOut className="mr-2 h-4 w-4" />
              LogOut
            </button>
          </div>
        </div>
      )}
    </>



    // new sidebar 

    // <>
    //   {isToggleSidebar && (
    //     <div
    //       ref={sidebarRef}
    //       className={`w-64 h-full flex flex-col transform transition-all duration-300 pl-2 custom-scrollbar ${isDarkMode ? "bg-darkmodeColor" : "bg-gradient-to-b from-white via-gray-50 to-white"} shadow-2xl border-r border-gray-200/50 dark:border-blue-500/20`}
    //     >
    //       {/* Header Section */}
    //       {/* <div className="p-4 border-b border-gray-200/50 dark:border-blue-500/20">
    //         <div className="flex items-center space-x-3">
    //           <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg flex items-center justify-center shadow-md">
    //             <span className="text-white font-bold text-sm">M</span>
    //           </div>
    //           <div>
    //             <h3 className="text-sm font-semibold text-gray-800 dark:text-white">Menu</h3>
    //             <p className="text-xs text-gray-500 dark:text-gray-400">Navigation</p>
    //           </div>
    //         </div>
    //       </div> */}

    //       <ul className="flex-1 p-2 space-y-1">
    //         {menuItems.map((item, index) => (
    //           <li key={index} className="group">
    //             <Button
    //               sx={{
    //                 fontFamily: 'var(--font-custom-open-sans)',
    //                 textTransform: 'none',
    //                 color: isDarkMode ? 'white' : 'rgba(1,14,78,0.96)',
    //                 width: '100%',
    //                 textAlign: 'left',
    //                 fontWeight: '600',
    //                 display: 'flex',
    //                 alignItems: 'center',
    //                 padding: '12px 16px',
    //                 borderRadius: '12px',
    //                 marginBottom: '4px',
    //                 position: 'relative',
    //                 overflow: 'hidden',
    //                 transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    //                 '&::before': {
    //                   content: '""',
    //                   position: 'absolute',
    //                   top: 0,
    //                   left: 0,
    //                   right: 0,
    //                   bottom: 0,
    //                   background: activeTab === index
    //                     ? 'linear-gradient(135deg, rgba(59, 130, 246, 0.15), rgba(147, 51, 234, 0.15))'
    //                     : 'transparent',
    //                   borderRadius: '12px',
    //                   transition: 'all 0.3s ease',
    //                 },
    //                 '&:hover': {
    //                   backgroundColor: 'transparent',
    //                   transform: 'translateX(4px)',
    //                   '&::before': {
    //                     background: 'linear-gradient(135deg, rgba(59, 130, 246, 0.1), rgba(147, 51, 234, 0.1))',
    //                   },
    //                 },
    //                 border: activeTab === index
    //                   ? '1px solid rgba(59, 130, 246, 0.3)'
    //                   : '1px solid transparent',
    //               }}
    //               onClick={() => toggleSubmenu(index, item.href)}
    //             >
    //               <div className="relative z-10 flex items-center w-full">
    //                 <div className={`
    //               flex items-center justify-center w-8 h-8 rounded-lg mr-3 transition-all duration-300
    //               ${activeTab === index
    //                     ? 'bg-gradient-to-br from-blue-500 to-purple-600 shadow-lg scale-110'
    //                     : 'bg-gradient-to-br from-gray-100 to-gray-200 dark:from-gray-700 dark:to-gray-600 group-hover:from-blue-400 group-hover:to-purple-500'}
    //             `}>
    //                   <span className={`
    //                 text-lg transition-colors duration-300
    //                 ${activeTab === index
    //                       ? 'text-white'
    //                       : 'text-gray-600 dark:text-gray-300 group-hover:text-white'}
    //               `}>
    //                     {item.icon}
    //                   </span>
    //                 </div>
    //                 <span className="flex-1 font-medium">
    //                   {item.title}
    //                 </span>
    //                 {item.submenu.length > 0 && (
    //                   <div className={`
    //                 transition-transform duration-300 p-1 rounded-full
    //                 ${activeTab === index ? 'rotate-180 bg-blue-100 dark:bg-blue-900/50' : 'group-hover:bg-gray-100 dark:group-hover:bg-gray-700'}
    //               `}>
    //                     <FaAngleDown className={`
    //                   text-sm transition-colors duration-300
    //                   ${activeTab === index
    //                         ? 'text-blue-600 dark:text-blue-400'
    //                         : 'text-gray-400 group-hover:text-gray-600 dark:group-hover:text-gray-300'}
    //                 `} />
    //                   </div>
    //                 )}
    //               </div>
    //             </Button>

    //             {item.submenu.length > 0 && activeTab === index && (
    //               <div className="submenuWrapper ml-4 mt-2 mb-2 overflow-hidden">
    //                 <div className={`${isDarkMode ? "bg-[rgba(1,14,78,0.8)]" : "bg-gradient-to-r from-gray-50 to-white"} rounded-xl p-3 border border-gray-200/50 dark:border-blue-500/20 shadow-inner`}>
    //                   <ul className="space-y-2">
    //                     {item.submenu.map((subItem, subIndex) => (
    //                       <li key={subIndex} className="relative group/sub">
    //                         <Link
    //                           to={subItem.href}
    //                           className={`
    //                         flex items-center px-3 py-2 rounded-lg text-sm font-medium transition-all duration-300 relative overflow-hidden
    //                         ${activeTab === index && activeSubTab === subIndex
    //                               ? 'bg-gradient-to-r from-blue-500 to-purple-600 text-white shadow-md transform scale-105'
    //                               : 'text-gray-600 dark:text-gray-300 hover:bg-gradient-to-r hover:from-blue-50 hover:to-purple-50 dark:hover:from-blue-900/30 dark:hover:to-purple-900/30 hover:text-blue-600 dark:hover:text-blue-400'}
    //                       `}
    //                           aria-label={subItem.title}
    //                         >
    //                           <div className={`
    //                         w-2 h-2 rounded-full mr-3 transition-all duration-300
    //                         ${activeTab === index && activeSubTab === subIndex
    //                               ? 'bg-white shadow-lg'
    //                               : 'bg-gray-300 dark:bg-gray-600 group-hover/sub:bg-blue-400 group-hover/sub:shadow-md'}
    //                       `}></div>
    //                           <span className="relative z-10">{subItem.title}</span>
    //                           {activeTab === index && activeSubTab === subIndex && (
    //                             <div className="absolute right-2 w-1 h-4 bg-white rounded-full shadow-md"></div>
    //                           )}
    //                         </Link>
    //                       </li>
    //                     ))}
    //                   </ul>
    //                 </div>
    //               </div>
    //             )}
    //           </li>
    //         ))}
    //       </ul>

    //       {/* Enhanced Logout Section */}
    //       <div className="p-4 mt-auto">
    //         <div className={`relative ${isDarkMode ? "bg-[rgba(1,14,78,0.8)]" : "bg-gradient-to-br from-blue-50 via-white to-purple-50"} p-6 rounded-2xl shadow-xl border border-gray-200/50 dark:border-blue-500/20 overflow-hidden`}>
    //           {/* Decorative Elements */}
    //           <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-blue-400/20 to-purple-400/20 rounded-full -translate-y-10 translate-x-10"></div>
    //           <div className="absolute bottom-0 left-0 w-16 h-16 bg-gradient-to-tr from-purple-400/20 to-pink-400/20 rounded-full translate-y-8 -translate-x-8"></div>

    //           <div className="relative z-10">
    //             <div className="flex items-center mb-4">
    //               <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center shadow-lg">
    //                 <LogOut className="h-5 w-5 text-white" />
    //               </div>
    //               <div className="ml-3">
    //                 <h4 className="text-sm font-semibold text-gray-800 dark:text-white">Ready to go?</h4>
    //                 <p className="text-xs text-gray-500 dark:text-gray-400">See you next time!</p>
    //               </div>
    //             </div>

    //             <button
    //               onClick={handleLogout}
    //               className="w-full flex items-center justify-center bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white font-medium py-3 px-4 rounded-xl transition-all duration-300 ease-in-out transform hover:scale-105 hover:shadow-lg group"
    //             >
    //               <LogOut className="mr-2 h-4 w-4 transition-transform duration-300 group-hover:rotate-12" />
    //               <span>Sign Out</span>
    //             </button>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   )}
    // </>

  );
};

export default Sidebar;
